import {Button} from "@mui/material";

const colors = {
  yellow: {
    backgroundColor: "#fde82b",
    color: "#000000",
  },
  black: {
    backgroundColor: "#000000",
    color: "#ffffff",
  }
};

export function BookButton({ color, onClick, ...baseProps }) {
  return (
    <Button
      {...baseProps}
      variant="contained"
      style={{
        ...colors[color],
        fontWeight: "bold",
      }}
      onClick={onClick}
    >
      BOOK FREE AT-HOME TEST RIDE
    </Button>
  );
}
